import { DecisionDetail } from "../../../models/home";
import { buildAction, buildConfidence, buildPriority, buildRisk, isoFromNow } from "./home-qa-harness.builders";

export const LOW_CONFIDENCE_DETAIL: DecisionDetail = {
  decision: {
    decisionId: "detail-low-confidence",
    state: "act_soon",
    title: "Confirm contract renewal path",
    shortReason: "The recommendation is plausible but the evidence still needs review before acting.",
    documents: [
      {
        documentId: "doc-detail-low-confidence",
        classificationId: "class-detail-low-confidence",
        title: "Master services agreement"
      }
    ],
    nextBestAction: buildAction("renew_contract", "Renew contract", true, {
      description: "Continue with the renewal only after checking the extracted clause.",
      completionCriteria: ["Review evidence", "Confirm renewal clause", "Validate effective date"]
    }),
    availableActions: [
      buildAction("review_evidence", "Go to evidence", true, {
        kind: "inspection",
        placement: "primary",
        executionMode: "inspect",
        description: "Stay in review mode and inspect the supporting evidence before acting.",
        completionCriteria: ["Review evidence", "Confirm renewal clause", "Validate effective date"]
      })
    ],
    priority: buildPriority(74, "medium", "The renewal notice window opens later this week."),
    risk: buildRisk("medium", "A wrong renewal path could create avoidable contract churn."),
    confidence: buildConfidence(0.64, ["Renewal clause confidence is still low."]),
    evidence: [
      {
        evidenceId: "evidence-low-confidence-1",
        type: "clause",
        label: "Renewal clause",
        value: "Detected with partial confidence in section 8.",
        confidence: 0.66,
        source: "contract-extractor",
        occurredAt: isoFromNow(-4)
      }
    ],
    missingInformation: [],
    owner: { userId: "u-4", displayName: "Legal Ops" },
    dueAt: isoFromNow(60),
    updatedAt: isoFromNow(-3),
    traceId: "detail-low-confidence-trace",
    sourceTrace: {
      traceId: "detail-low-confidence-trace",
      actionSource: "policy-engine",
      confidenceSource: "contract-classifier",
      explanationSource: "renewal-clause-evaluator",
      evaluatorVersion: "2026.05.10",
      rulesVersion: "home-ia-v3"
    }
  },
  activityPreview: [
    {
      eventId: "activity-low-confidence-1",
      decisionId: "detail-low-confidence",
      documentIds: ["doc-detail-low-confidence"],
      type: "decision.updated",
      title: "Evidence added",
      narrative: "The renewal clause was detected but still needs a manual review.",
      occurredAt: isoFromNow(-6)
    }
  ],
  relatedDecisionIds: ["detail-ready"]
};
